import { Loadable } from '../../components/common/loadable/loadable';

export const CreateOrganizationContainer = Loadable<any>({
  loader: () =>
    import(
      /* webpackChunkName: "create-organization" */ './create-organization'
    ).then((module) => module.CreateOrganizationContainer),
});
